
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 58 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.1 20.177h-2.9v-2.883c0-.764-.306-1.498-.85-2.038a2.909 2.909 0 00-4.1 0 2.873 2.873 0 00-.85 2.038v2.883h-2.9c-.77 0-1.507.303-2.05.844a2.873 2.873 0 000 4.076 2.91 2.91 0 002.05.844h2.9v2.883c0 .764.306 1.497.85 2.038a2.91 2.91 0 004.1 0c.544-.54.85-1.274.85-2.038V25.94h2.9a2.91 2.91 0 002.05-.844 2.873 2.873 0 000-4.076 2.909 2.909 0 00-2.05-.845zm-22.33 4.957a14.187 14.187 0 003.64-4.828c.85-1.85 1.29-3.86 1.29-5.894 0-3.823-1.528-7.488-4.247-10.19A14.545 14.545 0 0023.2 0a14.545 14.545 0 00-10.253 4.221A14.367 14.367 0 008.7 14.411c0 2.035.44 4.045 1.29 5.895a14.188 14.188 0 003.64 4.828 23.16 23.16 0 00-9.921 8.499A22.957 22.957 0 000 46.118c0 .764.306 1.497.85 2.038a2.91 2.91 0 004.1 0c.544-.54.85-1.274.85-2.038a17.24 17.24 0 015.096-12.23A17.454 17.454 0 0123.2 28.825c4.615 0 9.04 1.822 12.304 5.065A17.24 17.24 0 0140.6 46.118c0 .764.306 1.497.85 2.038a2.91 2.91 0 004.1 0c.544-.54.85-1.274.85-2.038a22.957 22.957 0 00-3.709-12.485 23.16 23.16 0 00-9.921-8.499zM23.2 23.06a8.738 8.738 0 01-4.834-1.457 8.658 8.658 0 01-3.204-3.881 8.599 8.599 0 01-.495-4.996 8.63 8.63 0 012.381-4.428 8.717 8.717 0 014.455-2.366 8.75 8.75 0 015.026.492 8.689 8.689 0 013.905 3.185 8.61 8.61 0 01-1.082 10.918A8.727 8.727 0 0123.2 23.06z"}})])
          )
        }
      }
    